<template>
  <div>
    <v-select
      v-if="!isLoading"
      :items="items"
      v-model="model"
      label="Shipping"
      :item-text="item => item.name + ' (' + item.price + `.- ${item.tax_included ? 'incl. tax' : 'excl. tax'})`"
      item-value="id"
      :disabled="!locationId || disabled"
      :rules="rules"
    >
      <template v-slot:append-item v-if="locationId && $can('access', 'Options')">
        <v-divider class="mb-2"></v-divider>
        <v-list-item @click="newItem()">
          <v-list-item-avatar color="grey lighten-3">
            <v-icon>mdi-plus</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Add custom shipping fee</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
    <shipping-form v-model="formOpen" v-on:add="addItem($event)" :id="locationId"></shipping-form>
  </div>
</template>

<script>
import ShippingForm from "@/components/shipping/ShippingForm.vue";
import {mapGetters} from "vuex";
export default {
  components: {
    ShippingForm
  },
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: [],
      formOpen: false
    };
  },
  props: {
    value: {
      type: [String, Number]
    },
    locationId: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    },
    locationId() {
      this.getList();
    }
  },
  mounted: function() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.locationId) {
        this.$store
          .dispatch("shippings/index", {
            filters: {
              locationId: this.locationId
            },
            pagination: {
              itemsPerPage: 1000
            }
          })
          .then(({shippings}) => {
            this.items = shippings.data;
            if(this.model){
              if(!this.items.find(item => item.id == this.model)){
                this.$store
                    .dispatch("shippings/view", this.model)
                    .then(({shipping}) => {
                      console.log(shipping);
                      this.items.push(shipping);
                      console.log(this.items);
                    })
                    .finally(() => (this.isLoading = false));
              }
            }
          })
          .finally(() => (this.isLoading = false));


      }
    },
    addItem(data) {
      this.getList();
      this.model = data.id;
    },
    newItem() {
      this.formOpen = true;
    }
  }
};
</script>
